import logo from "assets/images/brands/brand-main-sm.png";
import sidebar from "assets/images/brands/Exinitic.png";

export const clientName = "Exinitic";
export const developedBy = "Exinitic";

export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL ;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3001/";
export const companyName =  "Exinitic";
export const sidebarLogo = sidebar;
export const mainLogo = logo;
export const lightLogo = logo;
